(() => {
  if (window.nvEngravingGuard) return;
  const feeId = '62384637247818';
  const root = window.Shopify?.routes?.root || '/';
  let pending;
  function excessFees(cart) {
    let remaining = cart.items.filter(i => String(i.variant_id) !== feeId && String(i.properties?.['Ražba'] || i.properties?.Mintage || i.properties?.engraving || '').trim()).reduce((n,i) => n + i.quantity, 0);
    const updates = {};
    for (const item of cart.items.filter(i => String(i.variant_id) === feeId)) {
      const keep = Math.min(remaining, item.quantity);
      remaining -= keep;
      if (keep !== item.quantity) updates[item.key] = keep;
    }
    return updates;
  }
  async function reconcile() {
    const response = await fetch(root + 'cart.js', {cache:'no-store'});
    if (!response.ok) throw Error('Košík se nepodařilo ověřit. Zkuste to prosím znovu.');
    const cart = await response.json();
    const updates = excessFees(cart);
    if (!Object.keys(updates).length) return cart;
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(n=>n.dataset.sectionId))].slice(0,5);
    const changed = await fetch(root + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates,sections,sections_url:location.pathname})});
    const result = await changed.json();
    if (!changed.ok || result.errors) throw Error('Ražbu v košíku se nepodařilo ověřit. Zkuste to prosím znovu.');
    document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:result,sourceId:'nv-engraving-guard',data:{source:'product-form-component',sections:result.sections,itemCount:result.item_count}}}));
    return result;
  }
  window.nvEngravingGuard = () => pending || (pending = reconcile().finally(()=>{pending=null;}));
  const check = () => window.nvEngravingGuard().catch(e=>console.warn('[engraving]',e.message));
  document.addEventListener('cart:update', e=>{if(e.detail?.sourceId!=='nv-engraving-guard') check();});
  // Initial reconciliation only when a fee is already in the rendered cart.
  const initial = () => {if(document.querySelector('[data-nv-variant="'+feeId+'"]')) check();};
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initial,{once:true});else initial();
})();
